import { Component, OnInit, HostListener, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DataService } from 'src/shared/data/data.service';

@Component({
  selector: 'app-home-demo-two',
  templateUrl: './home-demo-two.component.html',
  styleUrls: ['./home-demo-two.component.scss']
})
export class HomeDemoTwoComponent implements OnInit,AfterViewInit {

  // @ViewChild('introVideo') introVideo!: ElementRef<HTMLVideoElement>;

  @ViewChild('introVideo')
  introVideo!: ElementRef<HTMLVideoElement>;

  set introVideoSetter(video: ElementRef<HTMLVideoElement>) {

  if (!video) {
    return;
  }

  this.introVideo = video;
  this.playIntroVideo();
}

  showWelcomeModal = false;
  isClosing = false;
  bannerData: any = null;
  bannerLoading: boolean = true;

  showWelcome = true;

  private played = false;

  constructor(
    private meta: Meta,
    private titleService: Title,
    private http: HttpClient,
    private data: DataService
  ) { }

  ngOnInit(): void {

    const visited = localStorage.getItem('kitchenMagicVisited');
    localStorage.setItem('kitchenMagicVisited', 'false');
    // this.showWelcomeModal = true;
    if (!visited) {
      this.showWelcomeModal = true;
      document.body.style.overflow = 'hidden'; // prevent scroll
    }
 

    this.titleService.setTitle('Kitchen Magic');
    this.meta.updateTag({ name: 'description', content: 'Visit Union Fire Production Qatar for advanced fire safety solutions and reliable protection systems. Discover high-quality fire fighting equipment and safety services for your projects.' });
    this.meta.updateTag({ name: 'keywords', content: 'Fire alarm systems, fire fighting equipment, safety maintenance services' });

    // this.loadBanner();

    // const welcomeShown = sessionStorage.getItem('welcomeShown');

    // if (!welcomeShown) {
    //   this.showWelcome = true;
    // } else {
    //   this.showWelcome = false;
    // }

    this.showWelcome = sessionStorage.getItem('welcomeShown') !== 'true';


  }



  //   ngAfterViewChecked() {

  //   if (this.showWelcome && !this.played && this.introVideo) {

  //     this.played = true;

  //     this.introVideo.nativeElement.load();

  //     this.introVideo.nativeElement.play()
  //       .then(() => console.log('Playing'))
  //       .catch(err => console.log(err));
  //   }

  // }


  // ngAfterViewChecked() {

  //   if (
  //     this.showWelcome &&
  //     !this.played &&
  //     this.introVideo
  //   ) {

  //     this.played = true;

  //     this.introVideo.nativeElement.load();

  //     this.introVideo.nativeElement.play()
  //       .then(() => {
  //         console.log('Playing');

  //         // Prevent showing again in this session
  //         sessionStorage.setItem('welcomeShown', 'true');
  //       })
  //       .catch(err => console.log(err));

  //   }

  // }


  ngAfterViewInit() {

    if (this.showWelcome) {

      setTimeout(() => {

        const video = this.introVideo?.nativeElement;

        if (video) {

          video.muted = true;
          video.load();

          video.play().catch(err => console.log(err));

        }

      });

    }

  }




  // hideWelcome() {

  //   this.showWelcome = false;

  // }

  hideWelcome(): void {

  sessionStorage.setItem('welcomeShown', 'true');

  this.showWelcome = false;

}

  loadBanner(): void {
    this.http.get(this.data.base_url + 'get_offer_banner_active/').subscribe({
      next: (response: any) => {
        if (response.status === 1 && response.data) {
          this.bannerData = response.data;
        }
        this.bannerLoading = false;
      },
      error: () => {
        this.bannerLoading = false;
      }
    });
  }

  getBannerImageUrl(): string {
    if (this.bannerData && this.bannerData.image) {
      return this.data.base_url + this.bannerData.image;
    }
    return '../../../../assets/img/offer-banner1.png';
  }

  getDiscountDisplay(): string {
    if (!this.bannerData) return '';
    if (this.bannerData.discount_type === 'percentage') {
      return `${this.bannerData.discount_value}% OFF`;
    } else {
      return `$${this.bannerData.discount_value} OFF`;
    }
  }


  slides: string[] = [
    'assets/img/slider/menu1.jpg',
    'assets/img/slider/menu2.jpg',
    'assets/img/slider/menu3.jpg',

  ];

  activeIndex = 0;
  scrollTimeout: any;

  @HostListener('window:wheel', ['$event'])
  onScroll(event: WheelEvent) {
    clearTimeout(this.scrollTimeout);

    this.scrollTimeout = setTimeout(() => {
      if (event.deltaY > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    }, 80);
  }

  nextSlide() {
    this.activeIndex =
      (this.activeIndex + 1) % this.slides.length;
  }

  prevSlide() {
    this.activeIndex =
      (this.activeIndex - 1 + this.slides.length) % this.slides.length;
  }


  // closeWelcomeModal() {
  //   this.showWelcomeModal = false;
  //   localStorage.setItem('kitchenMagicVisited', 'true');
  //   document.body.style.overflow = 'auto';
  // }


  closeWelcomeModal() {
    this.isClosing = true;

    setTimeout(() => {
      this.showWelcomeModal = false;
      this.isClosing = false;
      localStorage.setItem('kitchenMagicVisited', 'true');
      document.body.style.overflow = 'auto';
    }, 500); // match animation time
  }





  playIntroVideo(): void {

  if (!this.showWelcome || !this.introVideo) {
    return;
  }

  const video = this.introVideo.nativeElement;

  video.muted = true;
  video.playsInline = true;
  video.autoplay = true;

  const playVideo = () => {
    video.play()
      .then(() => {
        console.log('Video playing');
      })
      .catch(err => {
        console.log('Play failed', err);
      });
  };

  if (video.readyState >= 3) {
    playVideo();
  } else {

    video.addEventListener(
      'canplaythrough',
      () => {
        playVideo();
      },
      { once: true }
    );

    video.load();
  }
}
}